import { createFileRoute } from "@tanstack/react-router";

import { Listing } from "@/features/publisher";

export const Route = createFileRoute("/publisher/listing")({
  component: Listing,
});
